<template>
  <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
    <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Font Size</span>
    <div class="wf-w-1/2">
      <VueSlider
        ref="size-slider"
        v-model="fontSize"
        :interval="1"
        adsorb
        tooltip="none"
        :duration="0"
        :data="fontSizeClasses"
      />
    </div>
  </li>
</template>

<script>
  import _ from 'lodash'
  import { FontSizeClasses } from '../classes/FontSizeClasses'
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  export default MenuStyleProperty.extend({
    computed: {
      fontSizeClasses() {
        return Object.keys(FontSizeClasses)
      },
      fontSize: {
        get() {
          let currentFontSize = this.elementClasses(this.classes)[this.device].find(elementClass => this.fontSizeClasses.includes(elementClass.value))
          if (! currentFontSize) {
            currentFontSize = {property: 'FontSize', value: 'FONT_SIZE_XL', touched: false}
            this.addToArray(this.module, [currentFontSize], this.classes, this.device, {}, true, this.parentModule)
          }
          return currentFontSize.value
        },
        set: _.debounce(function (value) {
          let currentFontSize = this.elementClasses(this.classes)[this.device].find(elementClass => this.fontSizeClasses.includes(elementClass.value))
          value = {property: 'FontSize', value: value, touched: currentFontSize.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }, 250)
      },
    }
  })
</script>
